module.exports = __webpack_public_path__ + "static/media/iconPlenaria.4c15d1ce.svg";